export const PERSON_NAME = /^[a-z ,.'-]+$/i;

export const DURATION_OPTIONS = [
  { text: 'Within a week', key: 'Within a week', value: 'Within a week' },
  { text: 'Within a month', key: 'Within a month', value: 'Within a month' },
  { text: 'Within 3 months', key: 'Within 3 months', value: 'Within 3 months' },
  { text: 'Within 6 months', key: 'Within 6 months', value: 'Within 6 months' },
  { text: 'Within a year', key: 'Within a year', value: 'Within a year' },
];

export const DURATIONS = ['Within a week', 'Within a month', 'Within 3 months', 'Within 6 months', 'Within a year'];
